// component-cross-sell-bundle.js
(function() {
  function normalize(str = '') {
    return str
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  async function getBundleVariantId(bundleHandle, mainColor, crossColor) {
    const res = await fetch(`/products/${bundleHandle}.js`);
    if (!res.ok) {
      throw new Error(`Bundle prodotto non trovato: ${bundleHandle}`);
    }
    const product = await res.json();

    if (product.variants.length <= 1) {
      console.log(`Bundle ${bundleHandle}: unica variante id=${product.variants[0].id}`);
      return product.variants[0].id;
    }

  
    const normMain = normalize(mainColor);
    const normCross = normalize(crossColor);
    
    const variant = product.variants.find(v => {
      const o1 = normalize(v.option1);
      const o2 = normalize(v.option2);
      return (
        (o1 === normMain && o2 === normCross) ||
        (o1 === normCross && o2 === normMain)
      );
    });

    if (!variant) {
      console.error(`Variante non trovata per: "${mainColor}" + "${crossColor}"`);
      alert('La variante selezionata non è disponibile per questo bundle.');
      throw new Error('Variant lookup failed');
    }

    console.log(`Trovata variante id=${variant.id}`);
    return variant.id;
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer'],
        sections_url: '/cart'
      })
    });
    if (!res.ok) {
      throw new Error(`Add-to-cart failed: ${res.status}`);
    }
    return res.json();
  }

  function openAndRefreshDrawer(json) {
    if (window.eventBus) {
      eventBus.emit('update:cart:drawer', json);
      eventBus.emit('open:cart:drawer', { scrollToTop: true });
    } else {
      const html = json.sections?.['cart-drawer'];
      const container = document.querySelector('.cart-drawer')
                     || document.getElementById('shopify-section-cart-drawer');
      if (html && container) container.innerHTML = html;
      document.querySelector('[data-cart-toggle], .cart-toggle')?.click();
    }
  }

  window.crossSellHandler = async function(e) {
    e.preventDefault();

    const wrap = document.querySelector('.cross-sells-wrapper');
    const mainHandle = wrap?.dataset.mainHandle;
    if (!mainHandle) {
      return console.error('Main handle non trovato');
    }

    const container = e.currentTarget.closest('.cross-sell-item');
    if (!container) {
      return console.error('Cross-sell container non trovato');
    }

    const link = container.querySelector('a[href*="/products/"]');
    const crossHandle = link?.getAttribute('href').split('/products/')[1];
    if (!crossHandle) {
      return console.error('Cross-sell handle non trovato');
    }

    const mainChecked = document.querySelector(
      'product-swatch.is-color-swatch[data-option-index="0"] input:checked'
    );
    const mainColor = mainChecked?.value || '';
    const crossChecked = container.querySelector('input[type="radio"]:checked');
    const crossColor = crossChecked?.dataset.color || '';

    const bundleHandle = `${mainHandle}-${crossHandle}-bundle`;

    let bundleVid;
    try {
      bundleVid = await getBundleVariantId(bundleHandle, mainColor, crossColor);
    } catch (error) {
      console.error('Errore recupero variante bundle:', error);
      return;
    }

    try {
      const json = await addToCart(bundleVid);
      openAndRefreshDrawer(json);
    } catch (err) {
      console.error('Errore in addToCart/openDrawer:', err);
    }
  };

  window.initCrossSellButtons = function() {
    document.querySelectorAll('.test-cross-sell-button').forEach(btn => {
      const fresh = btn.cloneNode(true);
      btn.replaceWith(fresh);
      fresh.addEventListener('click', window.crossSellHandler);
    });
  };

  document.addEventListener('DOMContentLoaded', () => window.initCrossSellButtons());
  if (window.eventBus) eventBus.on('variant:change', window.initCrossSellButtons);

  // Supporto navigazione SPA
  (function() {
    const _push = history.pushState, _replace = history.replaceState;
    function emitLo() { window.dispatchEvent(new Event('locationchange')); }
    history.pushState = function() {
      _push.apply(this, arguments);
      emitLo();
    };
    history.replaceState = function() {
      _replace.apply(this, arguments);
      emitLo();
    };
    window.addEventListener('popstate', emitLo);
  })();
  window.addEventListener('locationchange', window.initCrossSellButtons);

})();
